import { getCommonTrackingParams } from 'Common/logging/tokens';
import { isMarketableLocation } from 'Src/utils/location';

/**
 * Returns the mloc objects associated with a set location objects based on `location.primary_marketable_location_id`
 * @param {object} config the config object
 * @param {array} locations array of location objects
 * @param {object} searchSDK - contains client and config info
 * @param {object} req the req object from the server
 * @returns {Promise<array>} the mloc objects
 */
export const getMlocsForLocations = async ({
  config,
  locations,
  searchSDK,
  req
}) => {
  try {
    const locationsWithMlocs = locations.filter(isMarketableLocation);

    if (locationsWithMlocs.length === 0) {
      return [];
    }

    const searchClient = searchSDK.current;
    const params = {
      ...getCommonTrackingParams({ config, req }),
      fields: ['-ALL', 'id', 'name', 'address', 'hours_of_operation'].join(','),
      filter: {
        or: {
          id: locationsWithMlocs.map((l) =>
            encodeURIComponent(l.primary_marketable_location_id)
          )
        }
      }
    };
    const {
      data: { _locations }
    } = await searchClient.getLocations(params);
    return _locations;
  } catch (e) {
    if (req) {
      const log = req.getLog();
      log.error(`error fetching mlocs for ${locations}`, { error: e });
    }
    return [];
  }
};
